<div class="padding-20 ui-g" *ngIf="show.form" id="productsTargetCouponForm">

  <!-- emissione -->
  <div class="ui-g-6 ui-g" [ngClass]="{'formHidden': formSchema.form.tipo_entita_emissione.visible == false }">
    <div class="ui-g-12 labelTitle">{{ 'campaign.on_emission' | translate }}</div>
    <br />
    <br />
    <br />
    <div class="ui-g-10">
      <app-form-fields #tipoEntitaEmissione data-testid="tipoEntitaEmissione" [readOnly]="readOnly"
        [fieldSchema]="formSchema.form.tipo_entita_emissione" (fieldModelChange)="onChangeTipoEntitaEmissione($event)"
        [(fieldModel)]="fieldModel.tipoEntitaEmissione"
        [placeholder]="'campaign.select_entity_type' | translate"></app-form-fields>

    </div>
    <div class="ui-g-2">
      <label>&nbsp;</label>
      <div *ngIf="!readOnly" [ngClass]="{'notPermitted': disablePlusEmissionType}"

      [ngClass]="{'notPermitted': tipoEntitaEmissione.disabled == true}" class="fa fa-plus circleIcon"
      (click)="onClickAddEntitaEmissione()"></div>
    </div>
    <div class="ui-g-12 ui-g targetListContainer">
      <div *ngFor="let pan of paniereListEmissioneSelected;let pan_i=index;" class="generalList ui-g-12 ui-g">
        <div class="ui-g-7">
          <div class="tl_col tl_eye"><span class="fa fa-eye" (click)="onClickShowEmission('P',pan_i)"></span></div>
          <div class="tl_col tl_info">{{ 'campaign.basket' | translate }}: {{pan.basketName}}</div>
          <div class="clear_fix"></div>
        </div>
        <div class="ui-g-5 ui-g">
          <span data-testid-generic="basketInclusionButton" class="inclusioneButton ui-g-5" data-testid-generic="basketInclusionButton" (click)="onClickInclusioneEmissione('P',pan_i)"
            [ngClass]="{'active': pan.inclusione_esclusione == 'I', 'notPermitted': readOnly==true}">{{'campaign.inclusion'
            | translate }}</span>
          <span data-testid-generic="basketExclusionButton" class="esclusioneButton ui-g-5" data-testid-generic="basketExclusionButton" (click)="onClickEsclusioneEmissione('P',pan_i)"
            [ngClass]="{'active': pan.inclusione_esclusione == 'E','notPermitted': readOnly==true}">{{
            'campaign.exclusion' | translate }}</span>
          <span *ngIf="!readOnly" class="ui-g-2 fa fa-trash" (click)="onClickDelEmissione('P',pan_i)"></span>
          <div *ngIf="!valid && !pan.valid" class="ui-g-12 errorMessage">{{'common.required_error' | translate}}</div>
        </div>
      </div>
      <div *ngFor="let dep of departmentListEmissioneSelected;let dep_i=index;" class="generalList ui-g-12">
        <div class="ui-g-7">
          <div class="tl_col tl_eye"><span class="fa fa-eye" (click)="onClickShowEmission('R',dep_i)"></span></div>
          <div class="tl_col tl_info">{{ 'campaign.department' | translate }}: {{dep.code}}<span
              *ngIf="dep.description"> - {{dep.description}}</span>
          </div>
        </div>
        <div class="ui-g-5 ui-g">
          <span data-testid-generic="deptInclusionButton" class="inclusioneButton ui-g-5" data-testid-generic="basketInclusionButton" (click)="onClickInclusioneEmissione('R',dep_i)"
            [ngClass]="{'active': dep.inclusione_esclusione == 'I', 'notPermitted': readOnly==true}">{{
            'campaign.inclusion' | translate }}</span>
          <span data-testid-generic="deptExclusionButton" class="esclusioneButton ui-g-5" data-testid-generic="basketExclusionButton" (click)="onClickEsclusioneEmissione('R',dep_i)"
            [ngClass]="{'active': dep.inclusione_esclusione == 'E','notPermitted': readOnly==true}">{{
            'campaign.exclusion' | translate }}</span>
          <span *ngIf="!readOnly" class="ui-g-2 fa fa-trash" (click)="onClickDelEmissione('R',dep_i)"></span>
          <div *ngIf="!valid && !dep.valid" class="ui-g-12 errorMessage">{{'common.required_error' | translate}}</div>
        </div>
      </div>
      <div *ngFor="let cat of categoriesListEmissioneSelected;let cat_i=index;" class="generalList ui-g-12">
        <div class="ui-g-7">
          <div class="tl_col tl_eye"><span class="fa fa-eye" (click)="onClickShowEmission('C',cat_i)"></span></div>
          <div class="tl_col tl_info">{{ 'campaign.category' | translate }}: {{cat.code}}<span *ngIf="cat.description">
              - {{cat.description}}</span>
          </div>
        </div>
        <div class="ui-g-5 ui-g">
          <span data-testid-generic="categoriesInclusionButton" class="ui-g-5 inclusioneButton ui-g-5" (click)="onClickInclusioneEmissione('C',cat_i)"
            [ngClass]="{'active': cat.inclusione_esclusione == 'I', 'notPermitted': readOnly==true}">{{
            'campaign.inclusion' | translate }}</span>
          <span data-testid-generic="categoriesExclusionButton" class="ui-g-5 esclusioneButton ui-g-5" (click)="onClickEsclusioneEmissione('C',cat_i)"
            [ngClass]="{'active': cat.inclusione_esclusione == 'E','notPermitted': readOnly==true}">{{
            'campaign.exclusion' | translate }}</span>
          <span *ngIf="!readOnly" class="ui-g-2 fa fa-trash" (click)="onClickDelEmissione('C',cat_i)"></span>
          <div *ngIf="!valid && !cat.valid" class="ui-g-12 errorMessage">{{'common.required_error' | translate}}</div>
        </div>
      </div>
      <div *ngFor="let pr of productsListEmissioneSelected;let pr_i=index;" class="generalList ui-g-12">
        <div class="ui-g-7">
          <div class="tl_col tl_eye"></div>
          <div class="tl_col tl_info">{{ 'campaign.product' | translate }}: {{pr.barcode}}<span
              *ngIf="pr.product_description"> -
              {{pr.product_description}}</span></div>
        </div>
        <div class="ui-g-5 ui-g">
          <span data-testid-generic="productExclusionButton" class="inclusioneButton ui-g-5" data-testid-generic="basketInclusionButton" (click)="onClickInclusioneEmissione('A',pr_i)"
            [ngClass]="{'active': pr.inclusione_esclusione == 'I', 'notPermitted': readOnly==true}">{{
            'campaign.inclusion' | translate }}</span>
          <span data-testid-generic="productInclusionButton" class="esclusioneButton ui-g-5" data-testid-generic="basketExclusionButton" (click)="onClickEsclusioneEmissione('A',pr_i)"
            [ngClass]="{'active': pr.inclusione_esclusione == 'E','notPermitted': readOnly==true}">{{
            'campaign.exclusion' | translate }}</span>
          <span *ngIf="!readOnly" class="ui-g-2 fa fa-trash" (click)="onClickDelEmissione('A',pr_i)"></span>
          <div *ngIf="!valid && !pr.valid" class="ui-g-12 errorMessage">{{'common.required_error' | translate}}</div>
        </div>
      </div>

    </div>
  </div>


  <!--
   <div class="ui-g-6 ui-g" [ngClass]="{'formHidden': formSchema.form.tipo_entita_emissione.visible == false }">
    <div class="ui-g-12 labelTitle">In Fruizione</div>
    <br />
    <br />
    <br />
    <div class="ui-g-10">
      <app-form-fields #tipoEntitaFruizione data-testid="tipoEntitaFruizione" [readOnly]="readOnly" [fieldSchema]="formSchema.form.tipo_entita_fruizione" (fieldModelChange)="onChangeTipoEntitaFruizione($event)" [(fieldModel)]="fieldModel.tipoEntitaFruizione" [placeholder]="'Seleziona il tipo di entità'"></app-form-fields>
    </div>
    <div class="ui-g-2">
      <label>&nbsp;</label>
      <div *ngIf="!readOnly" [ngClass]="{'notPermitted': tipoEntitaFruizione.disabled == true}" class="fa fa-plus circleIcon" (click)="onClickAddEntitaFruizione()"></div>
    </div>
    <div class="ui-g-12 ui-g targetListContainer">
      <div *ngFor="let pan of paniereListFruizioneSelected;let pan_i=index;" class="generalList ui-g-12 ui-g">
        <div class="ui-g-7">
          <div class="tl_col tl_eye"><span class="fa fa-eye" (click)="onClickShowFruition('P',pan_i)"></span></div>
          <div class="tl_col tl_info">Paniere: {{pan.basketName}}</div>
          <div class="clear_fix"></div>
        </div>
        <div class="ui-g-5 ui-g">
          <span class="inclusioneButton ui-g-5" (click)="onClickInclusioneFruizione('P',pan_i)" [ngClass]="{'active': pan.inclusione_esclusione == 'I','notPermitted': readOnly==true}">inclusione</span>
          <span class="esclusioneButton ui-g-5" (click)="onClickEsclusioneFruizione('P',pan_i)" [ngClass]="{'active': pan.inclusione_esclusione == 'E','notPermitted': readOnly==true}">esclusione</span>
          <span *ngIf="!readOnly" class="ui-g-2 fa fa-trash" (click)="onClickDelFruizione('P',pan_i)"></span>
          <div *ngIf="!valid && !pan.valid" class="ui-g-12 errorMessage">{{'common.required_error' | translate}}</div>
        </div>
      </div>
      <div *ngFor="let cat of categoriesListFruizioneSelected;let cat_i=index;" class="generalList ui-g-12">
        <div class="ui-g-7">
          <div class="tl_col tl_eye"><span class="fa fa-eye" (click)="onClickShowFruition('C',cat_i)"></span></div>
          <div class="tl_col tl_info">Categoria: {{cat.code}}<span *ngIf="cat.description"> - {{cat.description}}</span></div>
        </div>
        <div class="ui-g-5 ui-g">
          <span class="inclusioneButton ui-g-5" (click)="onClickInclusioneFruizione('C',cat_i)" [ngClass]="{'active': cat.inclusione_esclusione == 'I','notPermitted': readOnly==true}">inclusione</span>
          <span class="esclusioneButton ui-g-5" (click)="onClickEsclusioneFruizione('C',cat_i)" [ngClass]="{'active': cat.inclusione_esclusione == 'E','notPermitted': readOnly==true}">esclusione</span>
          <span *ngIf="!readOnly" class="ui-g-2 fa fa-trash" (click)="onClickDelFruizione('C',cat_i)"></span>
          <div *ngIf="!valid && !cat.valid" class="ui-g-12 errorMessage">{{'common.required_error' | translate}}</div>
        </div>
      </div>
      <div *ngFor="let pr of productsListFruizioneSelected;let pr_i=index;" class="generalList ui-g-12">
        <div class="ui-g-7">
          <div class="tl_col tl_eye"></div>
          <div class="tl_col tl_info">Articolo: {{pr.barcode}}<span *ngIf="pr.product_description"> - {{pr.product_description}}</span></div>
        </div>
        <div class="ui-g-5 ui-g">
          <span class="inclusioneButton ui-g-5" (click)="onClickInclusioneFruizione('A',pr_i)" [ngClass]="{'active': pr.inclusione_esclusione == 'I','notPermitted': readOnly==true}">inclusione</span>
          <span class="esclusioneButton ui-g-5" (click)="onClickEsclusioneFruizione('A',pr_i)" [ngClass]="{'active': pr.inclusione_esclusione == 'E','notPermitted': readOnly==true}">esclusione</span>
          <span  *ngIf="!readOnly" class="ui-g-2 fa fa-trash" (click)="onClickDelFruizione('A',pr_i)"></span>
          <div *ngIf="!valid && !pr.valid" class="ui-g-12 errorMessage">{{'common.required_error' | translate}}</div>
        </div>
      </div>
      <div *ngFor="let dep of departmentListFruizioneSelected;let dep_i=index;" class="generalList ui-g-12">
        <div class="ui-g-7">
          <div class="tl_col tl_eye"><span class="fa fa-eye" (click)="onClickShowFruition('R',dep_i)"></span></div>
          <div class="tl_col tl_info">Reparto: {{dep.code}}<span *ngIf="dep.description"> - {{dep.description}}</span></div>
        </div>
        <div class="ui-g-5 ui-g">
          <span class="inclusioneButton ui-g-5" (click)="onClickInclusioneFruizione('R',dep_i)" [ngClass]="{'active': dep.inclusione_esclusione == 'I','notPermitted': readOnly==true}">inclusione</span>
          <span class="esclusioneButton ui-g-5" (click)="onClickEsclusioneFruizione('R',dep_i)" [ngClass]="{'active': dep.inclusione_esclusione == 'E','notPermitted': readOnly==true}">esclusione</span>
          <span  *ngIf="!readOnly" class="ui-g-2 fa fa-trash" (click)="onClickDelFruizione('R',dep_i)"></span>
          <div *ngIf="!valid && !dep.valid" class="ui-g-12 errorMessage">{{'common.required_error' | translate}}</div>
        </div>
      </div>
    </div>
    </div>
  </div> -->


  <!-- MODAL VISUALIZZAZIONE ARTICOLO (utilizzato da bottone occhio paniere e reparto) -->
  <p-dialog *ngIf="show.modalViewProducts" [width]="1500" [height]="800" [(visible)]="show.modalViewProducts"
    [responsive]="true" [header]="title.modalViewProduct" showEffect="fade" [modal]="true">

    <app-campaign-3-view-products #viewProducts data-testid="viewProducts"
      [filters]="filtersViewProducts"></app-campaign-3-view-products>

    <!-- Bottone Annulla -->
    <div class="ui-dialog-footer buttonsContainer">
      <button pButton (click)="onClickAnnulla_ModalViewProducts()" type="button" class="k-generic-btn footer-btn"
        label="{{'common.cancel' | translate}}"></button>
      <div class="clear_fix"></div>
    </div>

  </p-dialog>




  <!-- MODAL DI EMISSIONE (aggiunta articolo, aggiunta reparto, aggiunta paniere, aggiunta categoria)-->

  <!-- selezione modal articolo -->
  <p-dialog *ngIf="show.modalArticoloEmissione" [width]="1500" [height]="800" [(visible)]="show.modalArticoloEmissione"
    [responsive]="true" [header]="'campaign.add_article' | translate " showEffect="fade" [modal]="true">

    <app-campaign-3-search-products #searchProductsEmission data-testid="searchProductsEmission"
      (productsListCancel)="onProductsCancelEmissione()" (productsListSelected)="onProductsSelectedEmissione($event)"
      [rowSelected]="{identifierField: 'id', arrayValues: productsListEmissioneSelected}"></app-campaign-3-search-products>

  </p-dialog>



  <!-- modal paniere emissione -->
  <p-dialog [width]="1500" [height]="800" [(visible)]="show.modalPaniereEmissione" [responsive]="true"
    [header]=" 'campaign.add_basket' | translate " showEffect="fade" [modal]="true">

    <app-campaign-3-search-paniere #searchBasketEmission data-testid="searchBasketEmission"
      *ngIf="show.modalPaniereEmissione" [paniereList]="list.emission.baskets"
      (paniereListCancel)="onPaniereCancelEmissione()" (paniereListSelected)="onPaniereSelectedEmissione($event)"
      (productsListSelected)="onNewBasket($event)"></app-campaign-3-search-paniere>


  </p-dialog>


  <!-- modal reaprto emissione -->
  <p-dialog *ngIf="show.modalRepartoEmissione" [width]="1500" [height]="800" [(visible)]="show.modalRepartoEmissione"
    [responsive]="true" [header]=" 'campaign.add_department' | translate " showEffect="fade" [modal]="true">

    <app-campaign-3-search-department #searchDepartmentEmission data-testid="searchDepartmentEmission"
      [departmentList]="list.emission.departments" (departmentListCancel)="onDepartmentCancelEmissione()"
      (departmentListSelected)="onDepartmentSelectedEmissione($event)"></app-campaign-3-search-department>


  </p-dialog>


  <!-- selezione modal categorie emissione -->
  <p-dialog [width]="1500" [height]="800" [(visible)]="show.modalCategoriaEmissione" [responsive]="true"
    [header]=" 'campaign.add_categories' " showEffect="fade" [modal]="true">

    <app-campaign-3-search-categories #searchCategoriesEmission data-testid="searchCategoriesEmission"
      *ngIf="show.modalCategoriaEmissione" [categoriesList]="list.emission.categories"
      (categoriesListCancel)="onCategoriesCancelEmissione()"
      (categoriesListSelected)="onCategoriesSelectedEmissione($event)"></app-campaign-3-search-categories>

  </p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/campaing-3-message/message-3-products-target/message-3-products-target.component.html